import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLanguage } from 'redux-i18n';

import Btn from "components/common/btn";

import { LANGUAGES_LIST } from '../../constants/index';
import { completeDatePickerLocale } from '../../helpers/datepicker-lang';
import { persistLanguage } from '../../helpers/language';
import { getLanguage } from '../../selectors/global';
import { getLoy3MembershipInfo } from '../../selectors/sandos4USelector';
import { iconChevron } from 'assets/img/public-auth';

class NavLanguage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  componentDidUpdate(prevProps) {
    // Activate the member language.
    if (prevProps.loyMemberInfo === undefined && this.props.loyMemberInfo !== undefined) {
      const userData = this.props.loyMemberInfo;
      const userLocale = userData.preferredLanguage;
      if (userLocale) {
        this.props.dispatch(setLanguage(userLocale));
        persistLanguage(userLocale);
        completeDatePickerLocale(userLocale);
      }
    }
  }

  setAppLanguage(lang) {
    this.props.dispatch(setLanguage(lang));
    completeDatePickerLocale(lang);
    persistLanguage(lang);
    if (typeof this.props.closeNavMenu === 'function') {
      this.props.closeNavMenu();
    }
    this.setState({ open: false });
  };

  toggleOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((prev) => ({ open: !prev.open }));
  };

  renderLangButton(lang, selectedLang) {
    return (
      <Btn key={lang}
        onClick={() => { this.setAppLanguage(lang); }}
        className={`py-2 px-3 font-bold ${lang === selectedLang ? 'text-black hover:text-primary' : 'text-secondary-900 hover:text-secondary-500'}`}>
      <span className="capitalize">{lang}</span>
    </Btn>
    )
  };

  render() {
    const { i18nLang, variant } = this.props;
    const isPublic = variant === 'public';
    const openClass = this.state.open ? 'is-open' : '';

    return (
      <div className={`sl-dropdown sl-dropdown--lang ${isPublic ? 'sl-dropdown--public' : ''} ${openClass}`}>
        <div
          className={`${isPublic ? 'public-lang-trigger' : 'hidden md:block px-4 nav-link'} uppercase font-bold cursor-pointer`}
          onClick={this.toggleOpen}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => { if (e.key === 'Enter' || e.key === ' ') this.toggleOpen(e); }}
        >
          <span>{i18nLang.toUpperCase()}</span>
          {isPublic ? (
            <img src={iconChevron} alt="" className="public-lang-chevron" />
          ) : (
            <span className="ml-1">˅</span>
          )}
        </div>

        <div className="sl-dropdown__content">
          <div className="flex items-center bg-white mx-2 mt-4 md:mt-1 md:shadow-md rounded-sm text-primary border-t md:border-t-0 border-secondary-800">
            {LANGUAGES_LIST.map(l => ( this.renderLangButton(l, i18nLang) ) )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  i18nLang: getLanguage(state),
  loyMemberInfo: getLoy3MembershipInfo(state),
});

export default withRouter(connect(mapStateToProps)(NavLanguage));
